import tw from 'tailwind-styled-components';
import styled from 'styled-components';

const Devider = styled.div`
    border-right-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity));
    margin-top: .5rem;
    margin-bottom: .5rem;
`;

// const Devider = tw.div`
//     border-r-2 border-gray-100 my-2
// `;

export default Devider